import { createContext } from 'react';

const AddressContext = createContext();

export default AddressContext;
